'use strict';

import {BehaviorSubject, combineLatest, debounceTime, switchMap, tap} from 'rxjs';
import AbstractChart from './abstract-chart';

const SORT_ORDER_DESC = 'desc';
const SORT_ORDER_ASC = 'asc';
export default class GenreTable extends AbstractChart {
  constructor(targetElementId, type = 'anime') {
    super();
    this.targetElementId = targetElementId;
    this.isLoadingSubject = new BehaviorSubject(false);
    this.type = type;
    this.data = {items: []};
    this.sortSubject = new BehaviorSubject({
      count: SORT_ORDER_DESC
    });
    this.filterSubject = new BehaviorSubject([
      {key: 'dated_at', value: 'wrap_up_year', label: 'Wrap-Up', type: 'check', position: 'filter'},
      {key: 'categories', value: 'genres', label: 'Genres', active: true, type: 'radio', position: 'category'},
      {key: 'categories', value: 'explicit_genres', label: 'Explicit Genres', type: 'radio', position: 'category'},
      {key: 'categories', value: 'themes', label: 'Themes', active: true, type: 'radio', position: 'category'},
      {key: 'categories', value: 'demographics', label: 'Demographics', type: 'radio', position: 'category'},
      {key: 'dated_at', value: 'past_year', label: 'Past Year', type: 'check', position: 'mal_filter'},
      {key: 'dated_at', value: 'custom', label: 'Custom Time', type: 'picker', position: 'mal_filter'},
      {key: 'score', value: '', label: 'List Score', type: 'select', position: 'mal_filter'},
    ]);
    this.isExpandSubject = new BehaviorSubject(false);
    this.subscribes = [];

    this.headers = [
      {key: null, label: '#', is_sort: false},
      {key: 'name', label: 'Genre / Theme', is_sort: true, order: SORT_ORDER_ASC},
      {key: 'count', label: 'Count', is_sort: true},
      {
        key: 'ratio',
        label: `% of ${type.charAt(0).toUpperCase() + type.slice(1)} List`,
        sp_label: '% of List',
        is_sort: false
      },
      {key: 'mean_score', label: 'Mean Score', sp_label: 'Mean<br/>Score', is_sort: true},
      {key: 'days', label: 'Days', is_sort: true},
      {key: 'weighted_score', label: 'Weighted', sp_label: 'Weighted<br/>Score', is_sort: true},
    ];
  }

  init() {
    this.$elm = $(`#${this.targetElementId}`);
    this.$tableTmpl = $.templates('#statistics-genre-table-tmpl');
    if (this.$elm.length) {
      this.setting();
    }
  }

  setting() {
    this.endpoint = this.$elm.data('endpoint');
    this.abortController = new AbortController();
    this.renderFilterButtons($('.filter', this.$elm), $.templates('#statistics-filter-button'));
    // event設定
    this.$elm.on('click', '.expand span', (ev) => this.isExpandSubject.next(!this.isExpandSubject.value));
    this.$elm.on('click', 'thead .sort', (ev) => {
      const sortKey = ev.currentTarget.dataset.key;
      const defaultOrder = ev.currentTarget.dataset.order || SORT_ORDER_DESC;
      if (this.sortSubject.value[sortKey]) {
        this.sortSubject.next({[sortKey]: this.sortSubject.value[sortKey] === SORT_ORDER_DESC ? SORT_ORDER_ASC : SORT_ORDER_DESC});
      } else {
        this.sortSubject.next({[sortKey]: defaultOrder});
      }
    });

    this.subscribes.push(this.isLoadingSubject.subscribe((isLoading) => {
      if (isLoading) {
        $('div.loading', this.$elm).removeClass('hidden');
        $('table', this.$elm).addClass('loading');
      } else {
        $('div.loading', this.$elm).addClass('hidden');
        $('table', this.$elm).removeClass('loading');
      }
    }));

    // expandはデータ取得しない
    this.subscribes.push(this.isExpandSubject.subscribe(() => this.render()));
    // 更新があったら再取得
    this.subscribes.push(
      combineLatest([this.sortSubject, this.filterSubject])
        .pipe(
          tap((v) => {
            this.render();
          }),
          debounceTime(150),
          switchMap(([sort, filters]) => this.load({...this.toParamSort(sort), ...this.toParamFilter(filters)}))
        )
        .subscribe(() => this.render())
    );
  }

  finishLoading() {
    $(`#${this.targetElementId}-footnote`).removeClass('hidden');
    const loading = $(`#${this.targetElementId}-loading`);
    if (!loading.hasClass('hidden')) {
      loading.addClass('hidden');
      document.dispatchEvent(new Event('statistics_loaded'));
    }
  }

  async load(params = {}) {
    const query = new URLSearchParams(params);
    if (this.isLoadingSubject.value) { // すでにDL中なら一度止める
      this.abortController.abort();
      this.abortController = new AbortController();
    }
    try {
      this.isLoadingSubject.next(true);
      const response = await fetch(`${this.endpoint}&${query}`, {signal: this.abortController.signal});
      const json = await response.json();
      if (json.result) {
        this.data = json;
      } else if (query.size > 0) { // もしresultがfalseでも、parameterをつけた状態でならitemsを空にしてデータを返す
        this.data = {...this.data, items: []};
      } else {
        this.data = {items: [], result: false};
      }
      this.isLoadingSubject.next(false);
    } catch (e) {
      if (!(e instanceof DOMException)) {
        this.data = {items: [], result: false};
        this.isLoadingSubject.next(false);
      }
    }
    // もしデータ量が足りてなかった場合は、足りないアラートを出す
    if (this.data.is_lt_10_title || !this.data.result) {
      $(`#${this.targetElementId}-nodata`).removeClass('hidden');
      $(`#${this.targetElementId}`).closest('.chart-root').addClass('nodata');
      $(`#${this.targetElementId}`).closest('.chart-root').find('.sp-toggle-filter-btn').prop('disabled', true);
      $(`#${this.targetElementId}-info`)
        .html($.templates('#statistics-info-list-le10-tmpl').render({...this.data, type: this.type}));
    }
    this.finishLoading();
  }

  render() {
    let items = this.isExpandSubject.value ? this.data.items : this.data.items.slice(0, 10);
    $('.table-wrapper', this.$elm).html(this.$tableTmpl.render({
      items,
      is_expand: this.isExpandSubject.value,
      headers: this.headers,
      sort: this.sortSubject.value
    }, {
      utils: {
        round: (val) => Math.round(val),
        isSort: (key, order = null) => order === null ? !!this.sortSubject.value[key] : this.sortSubject.value[key] === order,
        isViewExpand: () => this.data.items.length > 10
      }
    }));
  }
}

$(() => {
  (new GenreTable('profile-stats-anime-genre-table', 'anime')).init();
  (new GenreTable('profile-stats-manga-genre-table', 'manga')).init();
});
